import * as React from 'react';
import { useState } from 'react';

import { cn } from '@utils/cn';

import type { RadioButtonProps } from './RadioButton.types';

import {
  customRadioClasses,
  hiddenInputClasses,
  labelClasses,
  radioDotClasses
} from './RadioButton.styles';

export const RadioButton = ({
  onClick,
  name,
  value,
  children,
  className,
  checked: checkedProp,
  disabled = false
}: RadioButtonProps) => {
  const [internalChecked, setInternalChecked] = useState(false);

  // Use controlled mode if checked prop is provided, otherwise use internal state
  const isControlled = checkedProp !== undefined;
  const checked = isControlled ? Boolean(checkedProp) : internalChecked;

  if (!onClick) {
    console.warn('RadioButton onClick is required');
    return null;
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = e.target.checked;
    if (!isControlled) {
      setInternalChecked(newChecked);
    }
    if (newChecked) {
      onClick(value, name);
    }
  };

  return (
    <label htmlFor={`${name}-${value}`} className={cn(labelClasses({ disabled }), className)}>
      {!disabled && (
        <input
          id={`${name}-${value}`}
          type="radio"
          className={hiddenInputClasses()}
          onChange={handleChange}
          checked={checked}
          name={name}
          value={value}
        />
      )}

      <div className={cn(customRadioClasses({ checked }))}>
        <div className={cn(radioDotClasses({ checked }))} />
      </div>

      {children}
    </label>
  );
};
